import { Path } from "@/router";
import { NavLink } from "./types";
import { DOMAIN } from "@/hooks/useCapabilities";
import { MaterialNames } from "@/components/material_symbol_names";
import { FlagRecord } from "@/hooks/useFeatureFlags/flags";

export const defaultNavLinks = (flags: FlagRecord): Record<string, NavLink<Path>[]> => {
  return {
    Organization: [
      {
        domain: DOMAIN.EVERYONE,
        label: "Home",
        link: { to: "/home" as const },
        icon: "home" as MaterialNames
      },
      { domain: DOMAIN.EVERYONE, label: "People", link: { to: "/people" }, icon: "group" },
      { domain: DOMAIN.SECTIONS, label: "Sections", link: { to: "/sections" }, icon: "domain" },
      { domain: DOMAIN.FACILITIES, label: "Facilities", link: { to: "/facilities" }, icon: "store" }
    ],
    Manage: [
      ...(flags["backoffice-activities-screen"]
        ? [
            {
              domain: DOMAIN.EVERYONE,
              label: "Activities",
              link: { to: "/activities" as const },
              icon: "today" as MaterialNames
            }
          ]
        : [
            {
              domain: DOMAIN.EVERYONE,
              label: "Events",
              link: { to: "/events" as const },
              icon: "today" as MaterialNames
            }
          ]),
      {
        domain: DOMAIN.JOBS,
        label: "Jobs",
        link: { to: "/jobs" as const },
        icon: "business_center" as MaterialNames
      },
      {
        domain: DOMAIN.COMMERCE,
        label: "Billing",
        link: { to: "/billing" as const },
        icon: "card_membership" as MaterialNames
      },
      {
        domain: DOMAIN.EVERYONE,
        label: "Education",
        link: { to: "/education" as const },
        icon: "school" as MaterialNames
      }
    ].sort((a, b) => a.label.localeCompare(b.label))
  };
};
